import React, { useState } from 'react';
import { simulateAnalysis } from '../services/staticAnalysis';

/**
 * 📚 Módulo de Análisis con Contenido Pre-escrito
 * 
 * Muestra análisis geopolíticos curados sin necesidad de IA externa
 */
const AnalysisModule = ({ title, description, inputType, options, category, onSave, type }) => {
  const [input, setInput] = useState('');
  const [result, setResult] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleAnalyze = async () => {
    if (!input && inputType !== 'select') return;

    setIsLoading(true);
    setResult('');

    try {
      // Obtener análisis estático basado en la categoría y tema
      const topic = inputType === 'select' ? input : 'default';
      const analysis = await simulateAnalysis(category || 'general', topic);
      
      setResult(analysis);
      
      // Guardar en historial si se proporciona la función
      if (onSave) {
        onSave(input, analysis, type);
      }
    } catch (error) {
      console.error('Error obteniendo análisis:', error);
      setResult('**Error**\n\nNo se pudo cargar el análisis. Por favor intenta nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="card">
      <h2>{title}</h2>
      <p style={{ color: '#94a3b8', marginBottom: '1.5rem' }}>{description}</p>

      {inputType === 'select' ? (
        <select
          value={input}
          onChange={(e) => setInput(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem',
            borderRadius: '0.5rem',
            border: '1px solid rgba(148, 163, 184, 0.3)',
            background: 'rgba(15, 23, 42, 0.8)',
            color: '#f1f5f9',
            fontSize: '1rem'
          }}
        >
          <option value="">Seleccione un tema...</option>
          {options && options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : (
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ingrese su consulta aquí..."
          rows="4"
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem',
            borderRadius: '0.5rem',
            border: '1px solid rgba(148, 163, 184, 0.3)',
            background: 'rgba(15, 23, 42, 0.8)',
            color: '#f1f5f9',
            fontSize: '1rem',
            resize: 'vertical'
          }}
        />
      )}

      <button
        onClick={handleAnalyze}
        disabled={isLoading || (!input && inputType !== 'select')}
        style={{
          padding: '0.75rem 2rem',
          borderRadius: '0.5rem',
          border: 'none',
          background: isLoading ? 'rgba(100, 116, 139, 0.5)' : 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
          color: 'white',
          fontSize: '1rem',
          fontWeight: 'bold',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          transition: 'all 0.3s ease'
        }}
      >
        {isLoading ? '⏳ Analizando...' : '🔍 Analizar'}
      </button>

      {result && (
        <div style={{
          marginTop: '2rem',
          padding: '1.5rem',
          background: 'rgba(30, 41, 59, 0.8)',
          borderRadius: '0.5rem',
          border: '1px solid rgba(148, 163, 184, 0.2)'
        }}>
          <h3 style={{ 
            color: '#3b82f6', 
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            📊 Análisis
          </h3>
          <div style={{
            color: '#cbd5e1',
            lineHeight: '1.8',
            whiteSpace: 'pre-wrap'
          }}>
            {result.split('\n').map((line, idx) => {
              // Renderizar markdown básico
              if (line.startsWith('**') && line.endsWith('**')) {
                return (
                  <h4 key={idx} style={{ 
                    color: '#f1f5f9', 
                    marginTop: '1rem',
                    marginBottom: '0.5rem',
                    fontSize: '1.1rem'
                  }}>
                    {line.replace(/\*\*/g, '')}
                  </h4>
                );
              }
              if (line.startsWith('- ')) {
                return (
                  <li key={idx} style={{ marginLeft: '1.5rem', marginBottom: '0.5rem' }}>
                    {line.substring(2)}
                  </li>
                );
              }
              if (line.trim() === '') {
                return <br key={idx} />;
              }
              return <p key={idx} style={{ marginBottom: '0.5rem' }}>{line}</p>;
            })}
          </div>
        </div>
      )}
    </section>
  );
};

export default AnalysisModule;
